import { useColorScheme } from '@mui/material/styles'
import { useCallback, useEffect, useRef } from 'react'

export function useAppThemeMode() {
  const { mode, setMode } = useColorScheme()
  const setModeRef = useRef(setMode)
  const resolvedMode = mode === 'dark' ? 'dark' : 'light'

  useEffect(() => {
    setModeRef.current = setMode
  }, [setMode])

  const setAppMode = useCallback((nextMode: 'light' | 'dark') => {
    setModeRef.current(nextMode)
  }, [])

  return {
    mode: resolvedMode,
    setMode: setAppMode,
  } as const
}
